import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SecurityService } from 'src/app/services/security-service/security.service';
import { RoutesHistoricService } from 'src/app/services/routes-services/routes-historic-service/routes-historic.service';
import { BoService } from 'src/app/services/bo-service/bo.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { map } from 'rxjs/internal/operators/map';
import { OauthTokenData } from 'oauth-lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private translateService: TranslateService,
              private routesHistoricService: RoutesHistoricService,
              private userStorageService: UserStorageService,
              private securityService: SecurityService,
              private boService: BoService) {
                this.routesHistoricService.init();
  }

  ngOnInit() {
    if (this.userStorageService.getLang()) {
      this.translateService.use(this.userStorageService.getLang());
    } else {
      this.translateService.setDefaultLang(this.boService.getLanguage());
    }
    this.securityService.requestOAuthToken().pipe(
      map((token: OauthTokenData) =>  this.userStorageService.setOAuthToken(token.access_token))
    ).subscribe();
  }
}
